var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: false,
          expression: "false",
        },
      ],
      staticClass: "exit-dialog",
      attrs: {
        fullscreen: false,
        "close-on-press-escape": true,
        "show-close": false,
        "close-on-click-modal": false,
        visible: _vm.visible,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "exit-modal-header" }, [
        _c("div", { staticClass: "exit-modal-header-text" }, [
          _vm._v("\n      Replacements\n    "),
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "el-dialog__headerbtn",
            attrs: { type: "button", "aria-label": "Close" },
            on: {
              click: function ($event) {
                return _vm.$emit("update:visible", false)
              },
            },
          },
          [_c("i", { staticClass: "el-dialog__close el-icon el-icon-close" })]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticStyle: { border: "1px solid #DEE5EC" } }),
      _vm._v(" "),
      _c("div", { staticClass: "exit-modal-body" }, [
        _c("div", { staticClass: "warning-img" }, [
          _c("img", {
            staticStyle: {
              height: "48px",
              width: "100%",
              padding: "6px 0px 6px 4px",
            },
            attrs: { src: require("../../assets/warning-icon.svg") },
          }),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "exit-modal-title",
            staticStyle: { padding: "0px !important" },
          },
          [_vm._v("\n      Exit the flow?\n    ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "exit-modal-description",
            staticStyle: { padding: "0px !important" },
          },
          [_vm._v("\n      If you do this, you’ll need to start over.\n    ")]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticStyle: { padding: "16px 40px 24px 40px" } }, [
        _c("div", { staticClass: "flex flex-row exit-modal-buttons" }, [
          _c(
            "div",
            { staticStyle: { width: "100%" } },
            [
              _c(
                "el-button",
                {
                  staticClass: "cancel-button",
                  attrs: { "aria-label": "Close" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("update:visible", false)
                    },
                  },
                },
                [_vm._v("\n          Cancel\n        ")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { width: "100%" } },
            [
              _c(
                "el-button",
                {
                  staticClass: "exit-button",
                  on: { click: _vm.exitReplacement },
                },
                [_vm._v("\n          Exit\n        ")]
              ),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }